<template>
	<div>
		<div v-if="!assurance">
			اطلاعات کامل نمی باشد
		</div>
		<div style="direction: rtl;" v-else>
			<div style="text-align: center;margin-bottom: 25px;font-size: 18pt;position: relative;">
				رسید عودت ضمانت
			</div>
			<div style="text-align: justify;line-height: 2;margin-bottom: 15px;">
				بدینوسیله تایید می نمایم <b>{{ assuranceTitle }}</b> {{ assurance.assuranceType === 3 ? ' با مشخصات زیر ' : '' }} از طرف <b>{{ businessTitle }}</b>
				در تاریخ <b>{{ new Date().toLocaleDateString('fa-IR').toString().toPersianDigits() }} </b> تحویل اینجانب <b>{{ assurance.returnedToPerson }}</b>
				گردید.

			</div>

			<div style="margin-bottom: 30px;" v-if="(assurance.assuranceChequeItems || []).length">
				<div v-for="(cheque, index) in assurance.assuranceChequeItems" :key="cheque.id" style="margin: 10px;display: flex;flex-wrap: wrap;column-gap: 15px;">
					<div><b>{{ index + 1 }}</b></div>
					<div><b>تاریخ چک:</b>&nbsp;<span>{{ cheque.dueDate_Persian.date }}</span></div>
					<div><b>شماره چک:</b>&nbsp;<span>{{ cheque.chequeNumber }}</span></div>
					<div><b>شماره صیادی:</b>&nbsp;<span>{{ cheque.sayadiId }}</span></div>
					<div><b>مبلغ:</b>&nbsp;<span>{{ String(cheque.price).toPriceFormat() }}</span></div>
				</div>
			</div>

			<div style="display: flex;justify-content: space-between;padding: 20px">
				<div>اثر انگشت و امضا تحویل دهنده</div>
				<div>اثر انگشت و امضا تحویل گیرنده</div>
			</div>

		</div>
	</div>
</template>

<script>
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'ReturnAssurancePrintHtml',
		components: {
		},
		props: {
			assurance: {
				type: Object,
			}
		},
		data: () => ({
			html: '',
			userLoan: null,
			coinTypes: [{ id: 0, title: '-' }, { id: 1, title: 'ربع سکه' }, { id: 2, title: 'نیم سکه' }, { id: 3, title: 'تمام بهار' }, { id: 4, title: 'گرمی پارسیان و ...' }]
		}),
		mounted() {
			this.fillHtml()
		},
		computed: {
			...get('siteConfig', [
				'fullTitle'
			]),
			...get('appSettings', [
				'settings'
			]),
			businessTitle() {
				return this.settings?.businessTitle || this.fullTitle
			},
			assuranceTitle() {
				if (this.assurance.assuranceType === 3)
					return `${this.assurance.assuranceChequeItems.length} فقره چک`
				if (this.assurance.assuranceType === 4) {
					if (this.assurance.coinType !== 0) {
						var coin = this.coinTypes.find(x => x.id === this.assurance.coinType)
						return `۱ عدد ${coin?.title} ${this.assurance.coinType === 4 ? 'به وزن ' + this.assurance.goldWeight + ' گرم' : ''}`
					}
					return `۱ قطعه طلا به وزن ${this.assurance.goldWeight} گرم`
				}
				if (this.assurance.assuranceType === 1 || this.assurance.assuranceType === 2) {
					return `گواهی کسر از حقوق سازمانی بنام آقای/خانم ${this.assurance.personFullName} با کد ملی ${this.assurance.personNationalCode} مربوط به سازمان ${this.assurance.organization?.name}`
				}
				if (this.assurance.assuranceType === 0) {
					return this.assurance.description
				}
				return ''
			}
		},
		methods: {
			fillHtml() {
				this.$nextTick(() => {
					this.$emit('ready')
				})
			},
		}
	}
</script>
<style scoped></style>